var _rect, _rect2, _rect3, _path, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _path2, _line13, _line14, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddOrganizationBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "AddOrganization_Outline_24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1185",
    "data-name": "Rectangle 1185",
    width: 24,
    height: 24,
    fill: "#165cf3",
    opacity: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_986",
    width: 22,
    height: 22,
    transform: "translate(1.02 1)",
    fill: "none"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1186",
    "data-name": "Rectangle 1186",
    width: 22,
    height: 22,
    transform: "translate(1.02 1)",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M8.1,21.39V16.35a1.161,1.161,0,0,1,1.16-1.16h2.33a1.161,1.161,0,0,1,1.16,1.16h0v5.04",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_41",
    "data-name": "Line 41",
    y1: 11.19,
    transform: "translate(17.4 3.34)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    x2: 4.65,
    transform: "translate(12.75 21.39)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    y1: 4.39,
    transform: "translate(20.5 10.79)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    x2: 7.75,
    transform: "translate(12.75 21.39)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    x2: 1.55,
    transform: "translate(1.89 21.39)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    x1: 13.96,
    transform: "translate(3.44 21.39)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "Line_47",
    "data-name": "Line 47",
    x1: 3.1,
    transform: "translate(17.4 21.39)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    x1: 1.55,
    transform: "translate(20.5 21.39)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    id: "Line_49",
    "data-name": "Line 49",
    y1: 1.69,
    x2: 4.65,
    transform: "translate(1.89 7.29)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    id: "Line_50",
    "data-name": "Line 50",
    x1: 1.55,
    y2: 0.56,
    transform: "translate(17.4 2.78)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    id: "Line_51",
    "data-name": "Line 51",
    x2: 3.1,
    y2: 1.03,
    transform: "translate(17.4 9.76)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    id: "Line_52",
    "data-name": "Line 52",
    x1: 1.55,
    y1: 0.52,
    transform: "translate(20.5 10.79)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M6.54,7.29V2.78H3.44V21.39",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    id: "Line_53",
    "data-name": "Line 53",
    y1: 0.85,
    x2: 2.32,
    transform: "translate(15.08 3.34)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    id: "Line_54",
    "data-name": "Line 54",
    y1: 1.5,
    x2: 4.13,
    transform: "translate(6.54 5.79)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_188",
    "data-name": "Ellipse 188",
    cx: 0.57,
    cy: 0.57,
    r: 0.57,
    transform: "translate(12.18 4.45)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "add-circle",
    d: "M18.46,13.79a4.5,4.5,0,1,0,4.5,4.5,4.494,4.494,0,0,0-4.5-4.5Zm1.73,4.85H18.81v1.38a.35.35,0,1,1-.7,0V18.64H16.73a.35.35,0,1,1,0-.7h1.38V16.56a.35.35,0,0,1,.7,0v1.38h1.38a.35.35,0,1,1,0,.7Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddOrganizationBtnIcon);
export default __webpack_public_path__ + "static/media/add-organization-btn-icon.46bfe46774b7466202ce8aeb25b2dac4.svg";
export { ForwardRef as ReactComponent };